export const REPORT_PREVIEW_OPTIONS = {
  buSides: [
    { value: "parent_company", label: "By Parent" },
    { value: "level_1", label: "By Business Unit" },
    { value: "level_2", label: "By Company" },
    { value: "country", label: "By Country" },
    { value: "level_3", label: "By Site" },
  ],
};

export const resolvePreviewLabel = (options, value) => {
  if (!value) return "-";
  return options.find((option) => option.value === value)?.label || value;
};
